<div [id]="modalable.getModalId()" class="modal quicklink-modal signable-quick-qink" data-backdrop="static"
     data-keyboard="false" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <ng-container>
                    <img [attr.src]="assetService.getUrl('sidebar-quicklinks/yedo-logo.png')"
                         alt="Logo des Quicklinks"/>
                    @if (modalable && modalable.formData) {
                        <app-quicklink-sign-form [formData]="modalable.formData"
                                                 buttonText="Yedo öffnen"></app-quicklink-sign-form>
                    }
                    @if (!modalable || (!modalable.formData && modalable.status !== eResponseStatus.ERROR)) {
                        <p>Lade Daten...</p>
                    }

                    <button (click)="close()" class="btn btn-warning close-button" data-bs-dismiss="modal"
                            type="button">
                        <i aria-hidden="true" class="fa fa-times"></i>
                    </button>

                    @if (modalable) {
                        <div [ngClass]="{'error': modalable.status === eResponseStatus.ERROR || modalable.status === eResponseStatus.NOT_ACCESSIBLE, 'modal-footer': modalable.status === eResponseStatus.ERROR || modalable.status === eResponseStatus.NOT_ACCESSIBLE}">
                            <div [ngClass]="{'error-message': modalable.status === eResponseStatus.ERROR || modalable.status === eResponseStatus.NOT_ACCESSIBLE}">
                                @if (modalable.status === eResponseStatus.ERROR) {
                                    <span>Yedo derzeit nicht verfügbar. Versuche es später erneut.</span>
                                }
                                @if (modalable.status === eResponseStatus.NOT_ACCESSIBLE) {
                                    <span>Für diese Aktion wird ein Benutzerkonto benötigt.</span>
                                }
                                <button (click)="close()" data-bs-dismiss="modal">zurück zum Buch</button>
                            </div>
                        </div>
                    }
                </ng-container>
            </div>
        </div>
    </div>
</div>
